import { ReactNode } from 'react'
import { Box, styled, TextareaAutosize } from '@mui/material'
import { blue, grey } from '@mui/material/colors'

const borderRadiusValue = '15px'

export const Textarea = styled(TextareaAutosize)(
  ({ theme }) => `
  box-sizing: border-box;
  width: 100%;
  font-family: Inter;
  font-size: 1rem;
  font-weight: 400;
  line-height: 1.5;
  padding: 15px 12px;
  border-radius:${borderRadiusValue};
  color: ${theme.palette.mode === 'dark' ? grey[300] : grey[900]};
  background: ${theme.palette.lightGrey.main};
  border: 1px solid ${theme.palette.lightGrey.main};
  box-shadow: 0 2px 2px ${theme.palette.mode === 'dark' ? grey[900] : grey[50]};

  &:hover {
    border-color: black;
  }

  &:focus {
    border-color: ${theme.palette.primary.main};
    box-shadow: 0 0 0 3px ${theme.palette.mode === 'dark' ? blue[600] : blue[200]};
  }

  /* firefox */
  &:focus-visible {
    outline: 0;
  }
`,
)

export const StyledInputWrapper = ({ children }: { children: ReactNode }) => {
  return (
    <Box
      sx={{
        '& .MuiTextField-root': {
          display: 'flex',
          flexDirection: 'column',
          backgroundColor: 'lightGrey.main',
          borderRadius: borderRadiusValue,
        },
        '& .MuiOutlinedInput-root': {
          borderRadius: borderRadiusValue,
          '& fieldset': {
            borderColor: 'lightGrey.main', // aquí el color que quieras por defecto
          },
        },
        '& .MuiInputBase-root': {
          color: 'primary.main',
          borderRadius: borderRadiusValue,
        },

        '& .Mui-focused .MuiOutlinedInput-notchedOutline': {
          borderColor: 'primary.main',
        },
      }}>
      {children}
    </Box>
  )
}
